import React from 'react';
import {connect} from 'react-redux';
import {openSendRequestForm} from 'actions';
import {toastr} from 'react-redux-toastr';
import classnames from 'classnames';

class SendRequestButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.openPopupRequest = this.openPopupRequest.bind(this);
  }

  openPopupRequest() {
    if (this.props.auth && this.props.auth.isAuthenticated) {
      this.props.dispatch(openSendRequestForm(this.props.productId));
    } else {
      toastr.error('Lỗi!', 'Vui lòng đăng nhập gửi yêu cầu cho sản phẩm');
    }
  }

  render() {
    return (
      <button type="button" className={classnames({'send-request': !this.props.isDetail, 'button-white': this.props.isDetail})} onClick={this.openPopupRequest}>Gửi yêu cầu</button>
    );
  }
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  };
};

export default connect(bindStateToProps)(SendRequestButton);



// WEBPACK FOOTER //
// ./components/partials/send-request-button/send-request-button.jsx